<template>
  <v-container class="background-color: transparent">
    <v-row align="start" justify="center">
      <v-col cols="12" sm="12" md="6" xl="4">
        <p class="display-3">COMMANDS</p>
        <v-spacer></v-spacer>
        <v-divider />

        <v-card flat class="background-color: transparent">
          <v-card-title class="headline">
            <v-icon large color="primary" class="mr-5">code</v-icon>Syntax-Free commands
          </v-card-title>
          <v-card-text>
            <p>Commands are designed as easy as your notes.</p>

            <v-list color="grey lighten-3">
              <v-list-item>
                <v-list-item-title>BUY / SELL:</v-list-item-title>
                <v-list-item-subtitle>EURUSD: sell 2% sl @1.1212</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>PROTECT / BE:</v-list-item-title>
                <v-list-item-subtitle>EURUSD: protect 2% profit</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>EXIT:</v-list-item-title>
                <v-list-item-subtitle>EURUSD: close 50$; protect 90% profit</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <v-card flat class="background-color: transparent">
          <v-card-title class="headline mx-auto">
            <v-icon large color="primary" class="mr-5">dns</v-icon>Multi Terminals
          </v-card-title>
          <v-card-text>Trade everywhere, no limited for your creatives. No VPS to run your script, AE, robot,… we provide services that 99,9% online with serverless technology.</v-card-text>
          <v-card-subtitle>Support commands at:</v-card-subtitle>
          <v-card-title>
            <v-icon class="mx-2" color="primary" x-large>mdi-webhook</v-icon>Web Hook
            <v-icon class="mx-2" color="primary" x-large>email</v-icon>Email
            <v-icon class="mx-2" color="primary" x-large>mdi-telegram</v-icon>Telegram
            <v-icon class="mx-2" color="primary" x-large>mdi-application</v-icon>Web App
          </v-card-title>
          <br />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="4">
        <v-img
          :min-height="'calc(50vh - ' + $vuetify.application.top + 'px)'"
          src="@/assets/bluetheme/Command.png"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChartSetup",
  data() {
    return {};
  },
  methods: {
    flatformPath(item) {
      return require("@/assets/platforms/logos/" + item.logo);
    }
  }
};
</script>

<style>
</style>
